<template>
  <div class="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
    <!-- Logo -->
    <div class="mb-8 image-logo p-5 bg-white ">
      <img src="@/assets/logohp.png" alt="Logo" class=" h-auto mx-auto" />
    </div>

    <!-- Contenedor del formulario -->
    <div class="w-full max-w-md bg-white p-6 rounded-lg shadow-md">
      <h1 class="text-2xl font-bold mb-6 text-center">Iniciar Sesión</h1>

      <form @submit.prevent="handleFormSubmit">
        <!-- Campo de Email -->
        <div v-if="!emailConfirmed" class="mb-6">
          <label for="email" class="block text-gray-700 font-medium mb-2">Dirección de email</label>
          <input
            v-model="email"
            type="email"
            id="email"
            placeholder="ejemplo@mail.com"
            class="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring focus:ring-blue-500"
            @input="resetAnimation"
            @keyup.enter="startEmailAnimation"
          />
          <button
            type="button"
            @click="startEmailAnimation"
            class="w-full bg-blue-500 text-white font-medium py-3 mt-4 rounded-lg hover:bg-blue-600 transition"
          >
            Continuar
          </button>
        </div>

        <!-- Confirmación de Email -->
        <div v-if="emailConfirmed" class="mb-6 text-center">
          <p class="text-gray-700">
            <span class="font-bold">Correo:</span> {{ email }}
          </p>
          <button
            type="button"
            @click="editEmail"
            class="text-blue-500 hover:underline mt-2"
          >
            Editar correo
          </button>
        </div>

        <!-- Campo de Contraseña -->
        <div v-if="showPasswordInput" class="mb-6">
          <label for="password" class="block text-gray-700 font-medium mb-2">Contraseña</label>
          <input
            v-model="password"
            type="password"
            id="password"
            placeholder="••••••••"
            class="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring focus:ring-blue-500"
            @keyup.enter="handleLogin"
          />
          <button
            type="button"
            @click="handleLogin"
            class="w-full bg-green-500 text-white font-medium py-3 mt-4 rounded-lg hover:bg-green-600 transition"
          >
            Iniciar Sesión
          </button>
        </div>
      </form>

      <!-- Enlace para restablecer contraseña -->
      <div class="text-center mt-4">
        <a
          href="#"
          @click.prevent="navegarARestablecerAcceso"
          class="text-blue-500 hover:underline"
        >
          ¿Olvidaste la contraseña?
        </a>
      </div>
    </div>

    <!-- Caja para crear cuenta -->
    <div class="w-full max-w-md bg-gray-50 p-6 mt-6 rounded-lg shadow-md text-center">
      <p class="text-lg font-medium mb-4">¿No tienes una cuenta?</p>
      <button
        @click="goToRegister"
        class="w-full bg-blue-500 text-white font-medium py-3 rounded-lg hover:bg-blue-600 transition"
      >
        Crear una cuenta
      </button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from 'vuex';
import axios from "axios";

export default {
  data() {
    return {
      email: "",
      password: "",
      emailConfirmed: false,
      showPasswordInput: false,
      animating: false,
    };
  },
  methods: {
    ...mapActions(['login']),
    startEmailAnimation() {
      if (this.validateEmail(this.email)) {
        this.emailConfirmed = true;
        this.showPasswordInput = true;
      } else {
        alert("Por favor, introduce un correo electrónico válido.");
      }
    },
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    editEmail() {
      this.emailConfirmed = false;
      this.showPasswordInput = false;
    },
    resetAnimation() {
      this.emailConfirmed = false;
      this.showPasswordInput = false;
    },
    handleLogin() {
      if (this.alreadyLoggingIn) return;
      this.alreadyLoggingIn = true;
      
      axios.post('/api/login_post', {
        email: this.email,
        password: this.password,
      }).then(response => {
        console.log("Login response:", response.data);
        if (response.data.success) {
          console.log("Logging in user:", response.data.user);
          this.login(response.data.user).then(() => {
            console.log("Redirecting to dashboard");
            const redirect = '/dashboard';
            this.$router.push(redirect);
          }).catch(error => {
            console.error("Error after login action:", error);
          });
        } else {
          alert(response.data.error);
        }
      }).catch(error => {
        console.error('Error de inicio de sesión:', error);
        alert('Error en el servidor, intenta de nuevo más tarde.');
      }).finally(() => {
          this.alreadyLoggingIn = false; // Restablecer el estado
        });
    },

    navegarARestablecerAcceso() {
      this.$router.push("/reset-password");
    },
    goToRegister() {
      this.$router.push("/registrarse");
    },
    ...mapMutations(['setUser']),
  },
};
</script>
<style>
.image-logo {
  border-radius: 20px;
}
</style>